import { render } from "./Spinners.vue?vue&type=template&id=142e7e46&scoped=true"
const script = {}

import "./Spinners.vue?vue&type=style&index=0&id=142e7e46&scoped=true&lang=css"

import exportComponent from "/hpgdata/workspace/kumc_rnd_front_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142e7e46"]])

export default __exports__